import JdbcRoutes from '@/router/routes/jdbc';
import MongodbRoutes from '@/router/routes/mongodb';
import RedisRoutes from '@/router/routes/redis';
/**
 * 数据源的一些配置
 */
export const SOURCES_CONFIG = {
  mysql: {
    indexRouteName: 'JdbcIndex',
    indexRoutePath: '/console/jdbc/index',
    routes: JdbcRoutes
  },
  mongodb: {
    indexRouteName: 'MongodbIndex',
    indexRoutePath: '/console/mongodb/index',
    routes: MongodbRoutes
  },
  redis: {
    indexRouteName: 'RedisIndex',
    indexRoutePath: '/console/redis/index',
    routes: RedisRoutes
  }
};

/**
 * @IMPORTANT
 * 后端的数据库类型名称与前端的对照表，前端的代码逻辑中将仅使用对照后的大写形式的数据库名
 */
export const DATABASE_TYPE_TO_MARK = {
  mysql: 'MYSQL',
  hive: 'HIVE',
  mongodb: 'MONGODB',
  oracle: 'ORACLE ',
  redis: 'REDIS'
};

/**
 * 后端数据库类型名称与前端显示的名称的对照关系
 */
export const DATABASE_TYPE_TO_TYPE_LABEL = {
  mysql: 'MySQL',
  redis: 'Redis',
  mongodb: 'MongoDB',
  oracle: 'Oracle ',
  hive: 'Hive'
};

/**
 * 实例数据库的数据库类型与前端显示的名称的对照关系
 */
export const INSTANCE_DATABASE_TYPE_TO_TYPE_LABEL = {
  mongodb: 'MongoDB',
  mysql: 'MySQL',
  redis: 'Redis'
};

/**
 * 实例数据库的数据库类型与后端的数据库类型的对照关系
 */
export const INSTANCE_DATABASE_TYPE_TO_BE_DB_TYPE = {
  mysql: 'mysql',
  mongodb: 'mongodb',
  redis: 'redis'
};

/**
 * 地域的 cloudos 名称与后端接口需要的地域拼音名称的对照关系
 */
export const REGION_NAME_TO_PINYIN = {
  'cloudos-lf': 'langfang'
};

/**
 * 主题色
 */
export const PRIMARY_THEME_COLOR = '#00a0ff';
